import React from 'react';
import lgLogo from '../../assets/images/partners/lg-logo.png';
import Marquee from "react-fast-marquee";
import { partnerLogos } from "../../utils/getImages";


  

function BlogHomeEight() {
    // const logos = [
    //     noniusLogo, zafiroLogo, ipviewLogo, classinLogo, lgLogo, samsungLogo
    //   ];
    return (
        <>
            <section className="appie-blog-3-area appie-blog-8-area pt-90 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="appie-section-title text-center">
                                <h3 className="appie-title">Our Partners</h3>
                                <p>We are partnered with major companies.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* <div className="appie-blog-item-3 appie-blog-item-8 mt-30">
                                <div className="thumb"><a href='https://noniussolutions.com/' target='_blank'>
                                    <img src={noniusLogo} alt="" /></a>
                                </div>
                                <div className="thumb"><a href='https://www.zafiro.tv/en/' target='_blank'>
                                    <img src={zafiroLogo} alt="" /></a>
                                </div>
                                <div className="thumb"><a href='http://ipviewmedia.me/' target='_blank'>
                                    <img src={ipviewLogo} alt="" /></a>
                                </div>
                                <div className="thumb"><a href='https://www.classin.com/' target='_blank'>
                                    <img src={classinLogo} alt="" /></a>
                                </div>
                                <div className="thumb"><a href='https://www.lg.com/global/business/webos' target='_blank'>
                                    <img src={lgLogo} alt="" /></a>
                                </div>
                                <div className="thumb"><a href='https://www.samsung.com/us/business/displays/' target='_blank'>
                                    <img src={samsungLogo} alt="" /></a>
                                </div>
                            </div> */}

                            <div style={{ width: "90%", margin: "40px auto" }}>
      <Marquee pauseOnHover gradient={false} speed={50}>
        {partnerLogos.map((logo, index) => (
          <div
          key={index}
          style={{
              border: "2px solid #fff", // white border
              borderRadius: "8px",      // rounded corners
              padding: "10px 20px",     // space inside the box
              margin: "0 15px",         // space between logos
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff", // white background
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)", // subtle shadow
          }}
      >
          <img
              src={logo}
              alt={`logo-${index}`}
              style={{ height: "60px" }}
          />
      </div>
        ))}
      </Marquee>
    </div>


                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default BlogHomeEight;
